// extracted by mini-css-extract-plugin
module.exports = {"list":"Statistic_list__sicCu","title":"Statistic_title__tsR9l","list_top":"Statistic_list_top__3OiaF","button_list":"Statistic_button_list__2KE8m"};